/* Add officePhoneno, mobilePhoneNo, otherPhoneNo Aug 24, 2024 */
<template lang="pug">
	div(class="extr-nav")
		kt-table(
		ref="kt-table"
		p_appEntKey="extr"
		:p_cols="c_ktColumns" 
		:p_opts="c_ktOptions"
		)

</template>

<script>
import KTTable from "@/components/Ctrl/KT-Table.vue";
import util,{fn_hrefVwRec} from "@/utils/util.js";
import {refData} from "@/utils/ref-data.js";
export default {
	name: "extr-nav",
	components: {
		"kt-table": KTTable
	},
	data() {
		return {};
	},
	computed: {
		c_ktOptions() {
			return {};
		},
		c_ktColumns() {
			return [
				{
					field: "externalContactName",
					title:"Contact Name",
					default: true,
					sortable:true
				},
				{
					field: "accountName",
					title: "Account Name",
					default: true,
					//linkFn: (col, row, vc) => {return {path: fn_hrefVwRec('acct', row['accountNo'])};},
					sortable:true

				},
				{
					field: "role",
					title: "Title/Role",
					default: true,
					sortable:true
				},				
				{
					field: "email",
					default: true,
					datatype:"email",
					fn_hrefLink: (type,value)=> {return util.fn_hrefLink(type, value);},
					sortable:true
					
				},
				{field: "phoneNo",
					default: true,					
					datatype:"tel",
					valFmtFn: val => {return val?val.replace(/(\d{3})(\d{3})(\d{4})/,'$1.$2.$3'):null;},
					fn_hrefLink: (type,value)=> {return util.fn_hrefLink(type, value);},
					sortable:true

				},            
				{field: "officePhoneNo",
					title:"Office#",
					default: true,					
					datatype:"tel",
					valFmtFn: val => {return val?val.replace(/(\d{3})(\d{3})(\d{4})/,'$1.$2.$3'):null;},
					fn_hrefLink: (type,value)=> {return util.fn_hrefLink(type, value);},
					sortable:true

				},
				{field: "mobilePhoneNo",
					title:"Mobile#",
					default: true,					
					datatype:"tel",
					valFmtFn: val => {return val?val.replace(/(\d{3})(\d{3})(\d{4})/,'$1.$2.$3'):null;},
					fn_hrefLink: (type,value)=> {return util.fn_hrefLink(type, value);},
					sortable:true
				},
				{field: "otherPhoneNo",
					title:"Other#",
					default: true,					
					datatype:"tel",
					valFmtFn: val => {return val?val.replace(/(\d{3})(\d{3})(\d{4})/,'$1.$2.$3'):null;},
					fn_hrefLink: (type,value)=> {return util.fn_hrefLink(type, value);},
					sortable:true
				},
				{field: "address",sortable:true},

			];
		}
	},
	methods: {}
};


</script>

<style lang="less">
</style>